// extracted by mini-css-extract-plugin
export var alignCenter = "_a6-d";
export var bannerShown = "_a6-6";
export var buttonContent = "_a6-0";
export var cardList = "_a6-1";
export var centerContent = "_a6-2";
export var chevron = "_a6-3";
export var closePanelButton = "_a6-k";
export var conversationContextContainer = "_a6-l";
export var conversationDetailContainer = "_a6-4";
export var detailWrapper = "_a6-7";
export var dropdownButton = "_a6-e";
export var dropdownTitle = "_a6-9";
export var fullHeight = "_a6-5";
export var hidden = "_a6-a";
export var icon = "_a6-b";
export var mergeSuggestionWrapper = "_a6-m";
export var panel = "_a6-i";
export var portalButtonsWrapper = "_a6-c";
export var right = "_a6-j";
export var tableSummaryContainer = "_a6-8";
export var tableSummaryHeader = "_a6-g";
export var threeDotsButton = "_a6-f";
export var wide = "_a6-h";